/**
 * Pure HTTP helpers for BackendApiClient — extracted (P3). Behavior-preserving.
 */

import type { ApiErrorBody, ApiRequestError } from './backendApiClient.types';

export function appendFinanceListQueryParams(
  path: string,
  params?: Record<string, string | number | boolean>
): string {
  if (!params || Object.keys(params).length === 0) {
    return path;
  }
  const search = new URLSearchParams(
    Object.fromEntries(Object.entries(params).map(([key, value]) => [key, String(value)]))
  ).toString();
  return search ? `${path}?${search}` : path;
}

export function mapApiErrorBody(errorData: ApiErrorBody, status: number): ApiRequestError {
  const message = errorData.message || errorData.error || `API request failed: ${status}`;
  const base: ApiRequestError = {
    message,
    status,
    ...(errorData.code !== undefined ? { code: errorData.code } : {}),
  };

  const violations = errorData.details?.violations;
  if (Array.isArray(violations) && violations.length > 0) {
    base.errors = violations.map((violation, index) => ({
      id: `contract.violation.${index + 1}`,
      code: errorData.code ?? 'FLOW_CONTRACT_NOT_SATISFIED',
      message: violation,
      severity: 'error' as const,
    }));
  }

  return base;
}
